import { useGetServersQuery } from 'src/api_services/servers/query';
import { ServerRole } from 'src/orchd-client';
import { SelectField } from '../Select';
import { SelectOption } from '../SelectNew';
import { useGetSettingsQuery } from 'src/api_services/settings/query';
import { useMemo } from 'react';
import { SERVER_SELECTION_KEY } from 'src/pages/settings/Platform/ServerPlacement/ServerPlacement';
import { FormattedMessage, useIntl } from 'react-intl';
import { messages } from 'src/messages';

interface Props {
  role: ServerRole;
  currentId?: string;
  setId: (serverId: string) => void;
}

export const ServerSelectNew = ({ role, currentId, setId }: Props) => {
  const { data: servers = [] } = useGetServersQuery({});

  const { data: settings = [] } = useGetSettingsQuery();

  const { formatMessage } = useIntl();

  const method = settings.find((setting) => setting.name === SERVER_SELECTION_KEY)?.value || 'random';

  const placementLabel = useMemo(
    () =>
      method === 'random'
        ? formatMessage({
            id: 'platform_settings.server_placement.server_selection.random',
            defaultMessage: 'Random',
          })
        : method === 'leastLoad'
        ? formatMessage({
            id: 'platform_settings.server_placement.server_selection.least_load',
            defaultMessage: 'Least load',
          })
        : formatMessage({
            id: 'platform_settings.server_placement.server_selection.least_websites',
            defaultMessage: 'Least websites',
          }),
    [method, formatMessage]
  );

  const options: SelectOption[] = servers.map((server) => {
    return {
      label: server.friendlyName,
      value: server.id,
    };
  });

  console.log(settings);
  return (
    <SelectField
      options={options}
      label={<FormattedMessage {...messages[role]} />}
      onChange={(val) => setId(val.value[0].value.toString())}
      value={options.find((option) => option.value === currentId)}
      name={role}
      placeholder={placementLabel}
    />
  );
};
